import React, { useState, useRef, useEffect, useContext } from 'react';
import { useDispatch } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFilter } from '@fortawesome/free-solid-svg-icons'

import './LayerItem.css'
import { toggleSelected } from '../app/layers.js'
import { ReactReduxContext } from 'react-redux'
import apiClient from '../app/apiClient';
import {make_generic_proxy_url} from '../app/utils';

function LayerItem(props) {
  const dispatch = useDispatch()
  const authToken = apiClient.getAuthToken();

  return <div>
    <input type="checkbox"
      checked={props.checked}
      onChange={() => dispatch(toggleSelected({id: props.id}))}/>
    <span className={props.checked ? "layer-item selected" : "layer-item"}>
      {props.name}
    </span>
    {props.photoViewerHref && (
      <a
        href={props.photoViewerHref}
        style={{ marginLeft: 8, fontSize: "0.8em", color: "#0d47a1", fontWeight: 500 }}
        target="_blank"
        rel="noopener noreferrer"
      >
        Photo viewer
      </a>
    )}
    { props.colorBar && authToken &&
      <div style={{margin: "5px 0"}}>
        <div style={{ width:"80%", marginLeft:"10%"}}>
          <img style={{width: "100%"}} crossOrigin="anonymous" src={make_generic_proxy_url(props.colorBar.url, "file", authToken, {layerId: props.id})} alt="colorBar img missing" />
        </div>
        <div style={{ width: "90%", padding: "0% 5%", display: "flex", justifyContent: "space-between" }}>
          <p style={{margin: 0}}>{props.colorBar.min.value.toString()}{props.colorBar.min.unit}</p>
          <p style={{margin: 0}}>{props.colorBar.max.value.toString()}{props.colorBar.max.unit}</p>
        </div>
      </div>
    }
  </div>
}

export default LayerItem;